// Store reader — file row lookups (ARCHITECTURE.md §12.7).

import type { FileRow, StoreHandle } from "./types.js";

/** Look up a file row by path. */
export function getFileByPath(
  db: StoreHandle,
  path: string,
): FileRow | undefined {
  return db.backend.getFileByPath(path);
}

/** Return all stored file rows. */
export function getAllFiles(db: StoreHandle): FileRow[] {
  return db.backend.getAllFiles();
}
